import { z } from 'zod';
export const noteOrigins = ['customer', 'order', 'driver', 'truck', 'container'] as const;

/**
 * Order correction notes carry the before/after ids as real fields (see `fromId`/`toId`) so
 * "every correction involving customer X" is an indexed query rather than a string scan of
 * the note prose.
 */
export const noteCorrectionTypes = ['customer', 'address'] as const;

export const notesZ = z.object({
  content: z.string(),
  entityId: z.string(),
  origin: z.enum(noteOrigins),
  createdAt: z.date(),
  createdBy: z.string(),
  correctionType: z.enum(noteCorrectionTypes).optional(),
  fromId: z.string().optional(),
  toId: z.string().optional(),
});
